<template>
  <div class="" style="padding-bottom:20px;">
    <div class="table-box template-table">
      <loading :isShow="tableLoading" />
      <Table row-key="id" :columns="columns" :data="tableData" border>
        <template slot-scope="{ row }" slot="courseNum">
          <a class="course-num" @click="$refs.daliyDeatilRef.open(row.agentId)">{{ row.courseNum }}</a>
          /
          <span>{{ row.totalCourseNum }}</span>
        </template>

        <template slot-scope="{ row }" slot="trainNum">
          <a class="course-num" @click="$refs.trainDetail.open(row)">{{ row.trainNum }}</a>
          /
          <span>{{ row.totalTrainCounts }}</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
        style="text-align: center; margin-top: 20px" />
    </div>

    <!-- 学习课程数 -->
    <daliyDeatil ref="daliyDeatilRef"></daliyDeatil>

    <!-- 线下培训 -->
    <trainDetail ref="trainDetail" @suceess="searchAjax()"></trainDetail>

  </div>
</template>

<script>
import daliyDeatil from '@/pages/contentManagement/trainingCourse/courseRecord/components/daliyDeatil';
import trainDetail from '@/pages/contentManagement/trainingCourse/courseRecord/components/trainDetail';
export default {
  components: {
    daliyDeatil,
    trainDetail
  },
  data() {
    return {
      search: {
        trainType: 1
      },
      tableLoading: false, //表格loading
      columns: [
        //表格字段
        {
          title: '机构名称',
          align: 'center',
          key: 'orgName',
        },
        {
          title: '线上已学课程数/总课程数',
          align: 'center',
          slot: 'courseNum'
        },
        {
          title: '线下签到培训数/总培训数',
          align: 'center',
          slot: 'trainNum'
        },
        {
          title: '培训总时长',
          key: 'totalTime',
          align: 'center'
        }
      ],
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 10, //页容量
      pageNum: 1 //当前页
    };
  },
  methods: {
    async setData() {
      this.searchAjax();
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    getParams() {
      const params = Object.assign({}, this.search);
      return params;
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableLoading = true;
      this.$http({
        url: '/buz/staffTrainRecord/read/list',
        type: 'post',
        data: params,
        apiPermissionCode: 'org_100_0'
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.course-num {
  color: #236DFF;
}

style>
